module.exports = __webpack_public_path__ + "img/failAuditGreen.946bc986.png";